/**
 * Draft persistence via `ctx.shell.storage` (IndexedDB on Web, SQLite-k/v
 * on Desktop). Per neon's pre-cache-split review: drafts are plain k/v —
 * `workspace_id + view_id → content` — so they don't need the relational
 * structuredCache surface.
 *
 * `view_id` is a channel id or agent-DM id; consumers don't have to know
 * the difference.
 */
const DRAFT_PREFIX = "draft:";
function draftKey(workspaceId, viewId) {
    return `${DRAFT_PREFIX}${workspaceId}:${viewId}`;
}
export async function getDraft(ctx, workspaceId, viewId) {
    const value = await ctx.shell.storage.get(draftKey(workspaceId, viewId));
    return value ?? "";
}
export async function setDraft(ctx, workspaceId, viewId, content) {
    if (!content) {
        await ctx.shell.storage.delete(draftKey(workspaceId, viewId));
        return;
    }
    await ctx.shell.storage.set(draftKey(workspaceId, viewId), content);
}
export async function clearDraft(ctx, workspaceId, viewId) {
    await ctx.shell.storage.delete(draftKey(workspaceId, viewId));
}
/**
 * List drafts the current user has saved locally. Returns only entries
 * with non-empty content.
 */
export async function listDrafts(ctx, workspaceId) {
    const prefix = `${DRAFT_PREFIX}${workspaceId}:`;
    const keys = await ctx.shell.storage.keys(prefix);
    const entries = [];
    for (const key of keys) {
        const content = await ctx.shell.storage.get(key);
        if (!content)
            continue;
        entries.push({ viewId: key.slice(prefix.length), content });
    }
    return entries;
}
//# sourceMappingURL=drafts.js.map